import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const AccessGroupApi = {
  get: async function (groupId, cancel = false) {
    const response = await GApi.request({
      url: '/auth/access-group/' + groupId,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  getList: async function (cancel = false) {
    const response = await GApi.request({
      url: '/auth/access-group',
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  create: async function (post, cancel = false) {
    const response = await GApi.request({
      url: '/auth/access-group',
      method: 'POST',
      headers: defaultHeaders(),
      data: post,
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },

  update: async function (post, cancel = false) {
    const response = await GApi.request({
      url: '/auth/access-group/' + post.id,
      method: 'PUT',
      headers: defaultHeaders(),
      data: post,
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  delete: async function (groupId, cancel = false) {
    const response = await GApi.request({
      url: '/auth/access-group/' + groupId,
      method: 'DELETE',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

// defining the cancel API object for AccessGroupApi
const cancelApiObject = defineCancelApiObject(AccessGroupApi)
export default AccessGroupApi
